export default [
  {
    path: '/manutencao-mapeamentos',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Manutenção de Mapeamentos',
        path: '',
        component: () => import('@/views/mapeamentos/Index.vue'),
        meta: {
          requiresAuth: true,
          admin: true,
          breadcrumb: [{ name: 'Administração', path: '/administracao' }, { name: 'Manutenção de Mapeamentos' }]
        }
      }
    ]
  }
];
